export default __webpack_public_path__ + "static/Fusion-943a97fdcfe7c16191765a1b6ffa79d9.jpg";